import {
  Box,
  chakra,
  Flex,
  HTMLChakraProps,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import * as React from "react";
import { NavLink as ReactNavLink, useLocation } from "react-router-dom";

interface DesktopNavLinkProps extends HTMLChakraProps<"a"> {
  active?: boolean;
  to: string;
}

const DesktopNavLink = (props: DesktopNavLinkProps) => {
  const { active, to, ...rest } = props;
  const location = useLocation();
  const isActive = location.pathname.indexOf(to) !== -1;
  return (
    <chakra.a
      as={ReactNavLink}
      to={to}
      aria-current={isActive ? "page" : undefined}
      fontWeight="semibold"
      color={mode("gray.600", "gray.300")}
      {...rest}
      _activeLink={{
        color: mode("red.600", "red.300"),
        fontWeight: "bold",
      }}
    />
  );
};

interface MobileNavLinkProps {
  // icon: React.ElementType
  children: React.ReactNode;
  // href?: string;
  to: string;
}

const MobileNavLink = (props: MobileNavLinkProps) => {
  const { children, to } = props;
  return (
    <Flex
      as={ReactNavLink}
      to={to}
      m="-3"
      p="3"
      align="center"
      rounded="md"
      cursor="pointer"
      _hover={{ bg: mode("gray.50", "gray.600") }}
    >
      {/* <Icon as={icon} color={mode('red.600', 'red.400')} fontSize="xl" /> */}
      <Box marginStart="3" fontWeight="medium">
        {children}
      </Box>
    </Flex>
  );
};

export const NavLink = {
  Desktop: DesktopNavLink,
  Mobile: MobileNavLink,
};
